<template>
    <div class="modal fade" id="globalConfirmModal" tabindex="-1" aria-hidden="true">
      <div class="np-base-dialog modal-dialog modal-dialog-centered">
        <div class="modal-content shadow">
          <div class="modal-header border-0 p-3 pb-2">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
                <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
            </button> 
          </div>
          <div class="modal-body p-3 mt-4 mb-4">
            {{ message }}
          </div>
          <div class="modal-footer p-3">
            <button type="button" class="np-btn np-danger px-4" data-bs-dismiss="modal" @click="onCancel">{{ cancel }}</button>
            <button type="button" class="np-btn np-success-filled px-4" data-bs-dismiss="modal" @click="onConfirm">{{ ok }}</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
        title: {
            type: String,
            required: true,
        },        
        message: {
            type: String,
            required: true,
        },
        ok: {
            type: String,
            required: true,
        },
        cancel: {
            type: String,
            required: true,
        },        
    },
    emits: ["confirm", "cancel"],
    methods: {
      onConfirm() {
        this.$emit("confirm");
      },
      onCancel() {
        this.$emit("cancel");
      },
    },
  };
  </script>